import { render, staticRenderFns } from "./DataLoader.vue?vue&type=template&id=495ed4a5&scoped=true&"
import script from "./DataLoader.vue?vue&type=script&lang=js&"
export * from "./DataLoader.vue?vue&type=script&lang=js&"
import style0 from "./DataLoader.vue?vue&type=style&index=0&id=495ed4a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ed4a5",
  null
  
)

export default component.exports